<script>
import { Collapse } from 'ant-design-vue';

export default {
  components: { Collapse },
};
</script>

<template>
  <Collapse v-bind="$props">
    <slot></slot>
  </Collapse>
</template>

<style lang="scss" scoped></style>
